
import Wrapper from '@/components/MdxViewer';
import { makeServerSideProps } from '@/components/MdxViewer/serverSide';
import { Container } from '@mui/material';

import Content from './content.mdx';

export default () => (
    <Container maxWidth="lg" sx={{
        py: 10,
    }}>
        <Wrapper
            filePath="src/views/about/content.mdx"
            Component={Content} />
    </Container>
);

export const getServerSideProps = makeServerSideProps({
    app: {
        name: 'unrealos',
    },
    settings: {
        title: 'About Unrealos',
        description: 'Unrealos specializes in AI solutions, SaaS/PaaS platforms, and custom software development. With 20+ years of experience and global expertise, we deliver scalable, user-centric, and innovative technologies to empower businesses worldwide.',
    }
});